import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import DataEntryModal from '@grnhse/seedling/lib/birch/components/modals/data_entry_modal';
import { PrimaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { FraudReport } from '../types';
import FullFraudReport from './full_fraud_report';

const t = withLocalePrefix('fraud.full_fraud_report');

type FullFraudReportModalProps = {
  candidateName: string;
  report: FraudReport;
  isOpen: boolean;
  closeModal: () => void;
};

const FullFraudReportModal = ({
  candidateName,
  report,
  isOpen,
  closeModal,
}: FullFraudReportModalProps) => {
  return (
    <DataEntryModal
      size={'medium'}
      isOpen={isOpen}
      onDismiss={closeModal}
      ariaLabel={'full-fraud-report-modal'}
      data-provides="full-fraud-report-modal"
    >
      <DataEntryModal.Header onClick={closeModal}>
        {t('risk_signals')}
      </DataEntryModal.Header>

      <DataEntryModal.Body>
        <FullFraudReport candidateName={candidateName} report={report} />
      </DataEntryModal.Body>

      <DataEntryModal.Footer>
        <PrimaryButton onClick={closeModal}>{t('close')}</PrimaryButton>
      </DataEntryModal.Footer>
    </DataEntryModal>
  );
};

export default FullFraudReportModal;
